import React from 'react';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import DispatcherSelectorContainer from './../Containers/DispatcherSelectorContainer.jsx';
import RegressionViewContainer
  from './../Containers/RegressionViewContainer.jsx';
import TestDetailsModalContainer
  from './../Containers/TestDetailsModalContainer.jsx';
import CustomProtocolOpenerComponent
  from './../Components/CustomProtocolOpenerComponent';
import ConditionalComponent from './ConditionalComponent.jsx';
import { auth } from '../helpers';
import AcknowledgeBaselineUpdateModalContainer
  from './../Containers/AcknowledgeBaselineUpdateModalContainer.jsx';

const RegressionComponent = (props) => (
  <div>
    <ConditionalComponent condition =
      {props.pageType.hasComments && !auth.checkAuthenticated()}
    >
      <center>
        <p style={{ color:'red' }}>
          Comments cannot be added to scenarios if not logged in with JIRA credentials.
        </p>
      </center>
    </ConditionalComponent>
    <AcknowledgeBaselineUpdateModalContainer />
    <TestDetailsModalContainer />
    <Row style={{ margin: 0 }}>
      <Col sm={12} md={8} mdOffset={2} style={{ padding: 0 }}>
        <Row style={{ marginBottom: '15px' }}>
          <Col xs={12}>
            <DispatcherSelectorContainer />
          </Col>
        </Row>
        <Row style={{ marginBottom: '15px' }}>
          <RegressionViewContainer {...props} />
        </Row>
        <Row>
          <CustomProtocolOpenerComponent />
        </Row>
      </Col>
    </Row>
  </div>
);
RegressionComponent.propTypes = { pageType: PropTypes.object.isRequired };
export default RegressionComponent;


// WEBPACK FOOTER //
// src/Components/RegressionComponent.jsx